import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/** Пустое состояние: экран, которому нечего показать, но есть что предложить. */
export function Empty({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return (
    <div
      data-slot="empty"
      className={cn(
        'flex min-w-0 flex-col items-center justify-center gap-6 text-center',
        'px-6 py-12',
        className,
      )}
      {...props}
    />
  );
}

export function EmptyHeader({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return (
    <div
      data-slot="empty-header"
      className={cn('flex max-w-md flex-col items-center gap-2.5', className)}
      {...props}
    />
  );
}

export function EmptyMedia({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return (
    <div
      data-slot="empty-media"
      aria-hidden="true"
      className={cn(
        'mb-1 flex size-14 items-center justify-center rounded-2xl',
        'border border-border bg-(--surface-2) text-2xl',
        'shadow-(--shadow-soft)',
        className,
      )}
      {...props}
    />
  );
}

export function EmptyTitle({ className, ...props }: ComponentProps<'h2'>): JSX.Element {
  return (
    <h2
      data-slot="empty-title"
      className={cn('text-balance text-lg font-semibold text-foreground', className)}
      {...props}
    />
  );
}

export function EmptyDescription({ className, ...props }: ComponentProps<'p'>): JSX.Element {
  return (
    <p
      data-slot="empty-description"
      className={cn('text-pretty text-sm leading-relaxed text-muted-foreground', className)}
      {...props}
    />
  );
}

export function EmptyContent({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return (
    <div
      data-slot="empty-content"
      className={cn('flex flex-wrap items-center justify-center gap-2.5', className)}
      {...props}
    />
  );
}
